import { Action } from 'redux';
import {
  Agreement,
  FranchiseType,
  ConciliationDetail,
  ConciliationHeader,
  Company,
  Country,
  HttpErrorBaseAction,
  Management,
  MasterImportExecutionForm,
  MastersImport,
  MastersImportDetailFilter,
  FiscalDetail,
  FiscalDetailFilter,
  ConciliationHeaderState,
  ConciliationHeaderMeta,
  ConcHeaderStateCount,
  ConciliationDetailErrors,
  ConciliationDetailMeta,
  OpStructuresFilter,
  PodOptionType,
  PosType,
  Region,
  RegionalManagement,
  RemoteRequest,
  RemoteResource,
  ReportFilter,
  Stores,
  Supervision,
  ConciliationHeaderId,
  ConcDetErrorCount,
  ConcHeaderFilterByState,
  ConcDetailFilterByError,
} from '../../types';

export interface State {
  filters: ReportFilter;
  filterApplied: (keyof ReportFilter)[];
  opStructuresFilters: OpStructuresFilter;
  mastersImportFilters: MastersImportDetailFilter;
  posOptions: RemoteResource<string[]>;
  conciliationDetail: RemoteResource<ConciliationDetail[]>;
  conciliationHeader: RemoteResource<ConciliationHeader[]>;
  ConciliationHeaderStateOptions: RemoteResource<ConciliationHeaderState[]>;
  ConciliationDetailErrorsOptions: RemoteResource<ConciliationDetailErrors[]>;
  conciliationHeaderMeta: ConciliationHeaderMeta;
  conciliationDetailMeta: ConciliationDetailMeta;
  mastersImport: RemoteResource<MastersImport[]>;
  fiscalDetail: RemoteResource<FiscalDetail[]>;
  fiscalDetailFilters: FiscalDetailFilter;
  mastersTypes: RemoteResource<string[]>;
  mastersImportExecution: RemoteRequest;
}

export enum ActionType {
  changeFiltersCountry = 'report/changeFiltersCountry',
  changeFiltersStore = 'report/changeFiltersStore',
  changeConciliationDetailFiltersStore = 'report/changeConciliationDetailFiltersStore',
  changeConciliationDetailFilterStartAccountingDate = 'report/changeConciliationDetailFilterStartAccountingDate',
  changeConciliationDetailFilterEndAccountingDate = 'report/changeConciliationDetailFilterEndAccountingDate',
  changeFiltersPos = 'report/changeFiltersPos',
  changeFiltersSegments = 'report/changeFiltersSegments',
  changeFilterStartBusinessDate = 'report/changeFilterStartBusinessDate',
  changeFilterEndBusinessDate = 'report/changeFilterEndBusinessDate',
  changeFilterStartOperationDate = 'report/changeFilterStartOperationDate',
  changeFilterEndOperationDate = 'report/changeFilterEndOperationDate',
  changeFilterStartAccountingDate = 'report/changeFilterStartAccountingDate',
  changeFilterEndAccountingDate = 'report/changeFilterEndAccountingDate',
  findPosRequested = 'report/findPosRequested',
  findPosSuccess = 'report/findPosSuccess',
  findPosFailure = 'report/findPosFailure',
  findConciliationDetailRequested = 'report/findConciliationDetailRequested',
  findConciliationDetailSuccess = 'report/findConciliationDetailSuccess',
  findConciliationDetailFailure = 'report/findConciliationDetailFailure',
  changeConciliationDetailFilterByErrorFilter = 'report/changeConciliationDetailFilterByErrorFilter',
  findConciliationHeaderRequested = 'report/findConciliationHeaderRequested',
  findConciliationHeaderSuccess = 'report/findConciliationHeaderSuccess',
  findConciliationHeaderFailure = 'report/findConciliationHeaderFailure',
  changeConciliationHeaderFilterByStateFilter = 'report/changeConciliationHeaderFilterByStateFilter',
  changeOpStrucuresFilterAgreement = 'report/changeOpStrucuresFilterAgreement',
  changeOpStrucuresFilterRegionalManagement = 'report/changeOpStrucuresFilterRegionalManagement',
  changeOpStrucuresFilterRegion = 'report/changeOpStrucuresFilterRegion',
  changeOpStrucuresFilterManagement = 'report/changeOpStrucuresFilterManagement',
  changeOpStrucuresFilterSupervision = 'report/changeOpStrucuresFilterSupervision',
  changeOpStrucuresFilterCompany = 'report/changeOpStrucuresFilterCompany',
  changeFiltersStoreMotherChild = 'report/changeFiltersStoreMotherChild',
  changeMasterImportFilterCountry = 'report/changeMasterImportFilterCountry',
  changeMasterImportFilterStartImportDate = 'report/changeMasterImportFilterStartImportDate',
  changeMasterImportFilterEndImportDate = 'report/changeMasterImportFilterEndImportDate',
  changeMasterImportFilterState = 'report/changeMasterImportFilterState',
  changeFilterFederativeEntities = 'report/changeFilterFederativeEntities',
  changeFranchiseTypeFilter = 'report/changeFranchiseTypeFilter',
  changeConciliationHeaderId = 'report/changeConciliationHeaderId',
  changeFilterConciliationHeaderState = 'report/changeFilterConciliationHeaderState',
  changeFilterConciliationDetailErrors = 'report/changeFilterConciliationDetailErrors',
  findMastersImportRequested = 'report/findMastersImportRequested',
  findMastersImportSuccess = 'report/findMastersImportSuccess',
  findMastersImportFailure = 'report/findMastersImportFailure',
  findMastersTypesRequested = 'report/findMastersTypesRequested',
  findMastersTypesSuccess = 'report/findMastersTypesSuccess',
  findMastersTypesFailure = 'report/findMastersTypesFailure',
  mastersImportExecutionRequested = 'report/mastersImportExecutionRequested',
  mastersImportExecutionSuccess = 'report/mastersImportExecutionSuccess',
  mastersImportExecutionFailure = 'report/mastersImportExecutionFailure',
  findFiscalDetailRequested = 'dashboard/findFiscalDetailRequested',
  findFiscalDetailSuccess = 'dashboard/findFiscalDetailSuccess',
  findFiscalDetailFailure = 'dashboard/findFiscalDetailFailure',
  changeFiscalDetailFilterCountry = 'report/changeFiscalDetailFilterCountry',
  changeFiscalDetailFilterStartDate = 'report/changeFiscalDetailFilterStartImportDate',
  changeFiscalDetailFilterEndDate = 'report/changeFiscalDetailFilterEndImportDate',
  changeFiscalDetailFilterStore = 'report/changeFiscalDetailFilterStore',
}

export interface ChangeFilterCountryAction extends Action<ActionType.changeFiltersCountry> {
  countryCode: string;
}

export interface ChangeFilterStoreAction extends Action<ActionType.changeFiltersStore> {
  stores: Stores[];
}

export interface ChangeConciliationDetailFilterStoreAction
  extends Action<ActionType.changeConciliationDetailFiltersStore> {
  stores: Stores[];
}

export interface ChangeConciliationDetailFilterStartAccountingDateAction
  extends Action<ActionType.changeConciliationDetailFilterStartAccountingDate> {
  date: Date | null;
}

export interface ChangeConciliationDetailFilterEndAccountingDateAction
  extends Action<ActionType.changeConciliationDetailFilterEndAccountingDate> {
  date: Date | null;
}
export interface ChangeFilterPosAction extends Action<ActionType.changeFiltersPos> {
  pos: string[];
}

export interface ChangeFilterSegmentsAction extends Action<ActionType.changeFiltersSegments> {
  segments: PosType[];
}

export interface ChangeFilterStartBusinessDateAction
  extends Action<ActionType.changeFilterStartBusinessDate> {
  date: Date | null;
}

export interface ChangeFilterEndBusinessDateAction
  extends Action<ActionType.changeFilterEndBusinessDate> {
  date: Date | null;
}

export interface ChangeFilterStartOperationDateAction
  extends Action<ActionType.changeFilterStartOperationDate> {
  date: Date | null;
}

export interface ChangeFilterEndOperationDateAction
  extends Action<ActionType.changeFilterEndOperationDate> {
  date: Date | null;
}

export interface ChangeFilterStartAccountingDateAction
  extends Action<ActionType.changeFilterStartAccountingDate> {
  date: Date | null;
}

export interface ChangeFilterEndAccountingDateAction
  extends Action<ActionType.changeFilterEndAccountingDate> {
  date: Date | null;
}

export interface ChangeFilterStoreMotherChildAction
  extends Action<ActionType.changeFiltersStoreMotherChild> {
  pod: PodOptionType[];
}

export type FindPosRequestedAction = Action<ActionType.findPosRequested>;

export type FindPosSuccessAction = Action<ActionType.findPosSuccess> & {
  posOptions: string[];
};

export type FindPosFailureAction = HttpErrorBaseAction<ActionType.findPosFailure>;

export type ChangeClosingFilterConciliationDetailErrors =
  Action<ActionType.changeFilterConciliationDetailErrors>;

export type FindConciliationDetailRequestedAction =
  Action<ActionType.findConciliationDetailRequested> & {
    sendToOndrive: boolean;
  };

export type FindConciliationDetailSuccessAction =
  Action<ActionType.findConciliationDetailSuccess> & {
    conciliationDetail: ConciliationDetail[];
    errorsCounts: ConcDetErrorCount;
  };

export type FindConciliationDetailFailureAction =
  HttpErrorBaseAction<ActionType.findConciliationDetailFailure>;

export interface ChangeConciliationDetailFilterByErrorFilterAction
  extends Action<ActionType.changeConciliationDetailFilterByErrorFilter> {
  filterByError: string;
}

export type FindConciliationHeaderRequestedAction =
  Action<ActionType.findConciliationHeaderRequested> & {
    sendToOndrive: boolean;
  };

export type FindConciliationHeaderSuccessAction =
  Action<ActionType.findConciliationHeaderSuccess> & {
    conciliationHeader: ConciliationHeader[];
    statesCounts: ConcHeaderStateCount;
  };

export type FindConciliationHeaderFailureAction =
  HttpErrorBaseAction<ActionType.findConciliationHeaderFailure>;

export interface ChangeConciliationHeaderFilterByStateFilterAction
  extends Action<ActionType.changeConciliationHeaderFilterByStateFilter> {
  filterByState: string;
}

export interface ChangeOpStrucuresFilterAgreementAction
  extends Action<ActionType.changeOpStrucuresFilterAgreement> {
  agreement: Agreement[];
}

export interface ChangeOpStrucuresFilterRegionalManagementAction
  extends Action<ActionType.changeOpStrucuresFilterRegionalManagement> {
  regionalMgmt: RegionalManagement[];
}

export interface ChangeOpStrucuresFilterRegionAction
  extends Action<ActionType.changeOpStrucuresFilterRegion> {
  region: Region[];
}

export interface ChangeOpStrucuresFilterManagementAction
  extends Action<ActionType.changeOpStrucuresFilterManagement> {
  management: Management[];
}

export interface ChangeOpStrucuresFilterSupervisionAction
  extends Action<ActionType.changeOpStrucuresFilterSupervision> {
  supervision: Supervision[];
}

export interface ChangeOpStrucuresFilterCompanyAction
  extends Action<ActionType.changeOpStrucuresFilterCompany> {
  company: Company[];
}

export interface ChangeMastersImportFilterCountryAction
  extends Action<ActionType.changeMasterImportFilterCountry> {
  countries: Country[];
}

export interface ChangeMastersImportFilterStartImportDateAction
  extends Action<ActionType.changeMasterImportFilterStartImportDate> {
  date: Date | null;
}

export interface ChangeMastersImportFilterEndImportDateAction
  extends Action<ActionType.changeMasterImportFilterEndImportDate> {
  date: Date | null;
}

export interface ChangeMastersImportFilterStateAction
  extends Action<ActionType.changeMasterImportFilterState> {
  state: string[];
}

export interface ChangeFilterFederativeEntitiesAction
  extends Action<ActionType.changeFilterFederativeEntities> {
  federativeEntities: string[];
}

export interface ChangeFranchiseTypeFilterAction
  extends Action<ActionType.changeFranchiseTypeFilter> {
  franchiseTypes: FranchiseType[];
}

export interface ChangeConciliationHeaderIdAction
  extends Action<ActionType.changeConciliationHeaderId> {
  conciliationHeaderId: ConciliationHeaderId;
}

export interface ChangeClosingFilterConciliationHeaderStateAction
  extends Action<ActionType.changeFilterConciliationHeaderState> {
  causeTypes: ConciliationHeaderState[];
}
export interface ChangeClosingFilterConciliationDetailErrorsAction
  extends Action<ActionType.changeFilterConciliationDetailErrors> {
  causeTypes: ConciliationDetailErrors[];
}

export type FindMastersImportRequestedAction = Action<ActionType.findMastersImportRequested>;

export type FindMastersImportSuccessAction = Action<ActionType.findMastersImportSuccess> & {
  mastersImport: MastersImport[];
};

export type FindMastersImportFailureAction =
  HttpErrorBaseAction<ActionType.findMastersImportFailure>;

export type FindMastersTypesRequestedAction = Action<ActionType.findMastersTypesRequested>;

export type FindMastersTypesSuccessAction = Action<ActionType.findMastersTypesSuccess> & {
  mastersTypes: string[];
};

export type FindMastersTypesFailureAction = HttpErrorBaseAction<ActionType.findMastersTypesFailure>;

export interface MastersImportExecutionRequestedAction
  extends Action<ActionType.mastersImportExecutionRequested> {
  payload: MasterImportExecutionForm;
}

export type MastersImportExecutionSuccessAction = Action<ActionType.mastersImportExecutionSuccess>;

export type MastersImportExecutionFailureAction =
  HttpErrorBaseAction<ActionType.mastersImportExecutionFailure>;

export type FindFiscalDetailRequestedAction = Action<ActionType.findFiscalDetailRequested>;

export type FindFiscalDetailSuccessAction = Action<ActionType.findFiscalDetailSuccess> & {
  fiscalDetail: FiscalDetail[];
};

export type FindFiscalDetailFailureAction = HttpErrorBaseAction<ActionType.findFiscalDetailFailure>;

export interface ChangeFiscalDetailFilterCountryAction
  extends Action<ActionType.changeFiscalDetailFilterCountry> {
  countries: Country[];
}

export interface ChangeFiscalDetailFilterStartDateAction
  extends Action<ActionType.changeFiscalDetailFilterStartDate> {
  date: Date | null;
}

export interface ChangeFiscalDetailFilterEndDateAction
  extends Action<ActionType.changeFiscalDetailFilterEndDate> {
  date: Date | null;
}

export interface ChangeFiscalDetailFilterStoreAction
  extends Action<ActionType.changeFiscalDetailFilterStore> {
  stores: Stores[];
}

export type Actions =
  | ChangeFilterCountryAction
  | ChangeFilterStoreAction
  | ChangeConciliationDetailFilterStoreAction
  | ChangeConciliationDetailFilterStartAccountingDateAction
  | ChangeConciliationDetailFilterEndAccountingDateAction
  | ChangeFilterPosAction
  | ChangeFilterSegmentsAction
  | ChangeFilterStartAccountingDateAction
  | ChangeFilterEndAccountingDateAction
  | ChangeFilterStartBusinessDateAction
  | ChangeFilterEndBusinessDateAction
  | ChangeFilterStartOperationDateAction
  | ChangeFilterEndOperationDateAction
  | FindPosRequestedAction
  | FindPosSuccessAction
  | FindPosFailureAction
  | ChangeOpStrucuresFilterAgreementAction
  | ChangeOpStrucuresFilterRegionalManagementAction
  | ChangeOpStrucuresFilterRegionAction
  | ChangeOpStrucuresFilterManagementAction
  | ChangeOpStrucuresFilterSupervisionAction
  | ChangeOpStrucuresFilterCompanyAction
  | ChangeFilterStoreMotherChildAction
  | ChangeMastersImportFilterCountryAction
  | ChangeMastersImportFilterStartImportDateAction
  | ChangeMastersImportFilterEndImportDateAction
  | ChangeMastersImportFilterStateAction
  | FindMastersImportRequestedAction
  | FindMastersImportSuccessAction
  | FindMastersImportFailureAction
  | FindMastersTypesRequestedAction
  | FindMastersTypesSuccessAction
  | FindMastersTypesFailureAction
  | MastersImportExecutionRequestedAction
  | MastersImportExecutionSuccessAction
  | MastersImportExecutionFailureAction
  | FindConciliationDetailRequestedAction
  | FindConciliationDetailSuccessAction
  | FindConciliationDetailFailureAction
  | FindConciliationHeaderRequestedAction
  | FindConciliationHeaderSuccessAction
  | FindConciliationHeaderFailureAction
  | ChangeConciliationHeaderFilterByStateFilterAction
  | ChangeClosingFilterConciliationHeaderStateAction
  | ChangeClosingFilterConciliationDetailErrorsAction
  | ChangeClosingFilterConciliationDetailErrorsAction
  | ChangeFranchiseTypeFilterAction
  | ChangeFilterFederativeEntitiesAction
  | ChangeConciliationHeaderIdAction
  | FindFiscalDetailRequestedAction
  | FindFiscalDetailSuccessAction
  | FindFiscalDetailFailureAction
  | ChangeFiscalDetailFilterCountryAction
  | ChangeFiscalDetailFilterStoreAction
  | ChangeFiscalDetailFilterStartDateAction
  | ChangeFiscalDetailFilterEndDateAction
  | ChangeConciliationDetailFilterByErrorFilterAction;
